import { Text } from "@convertkit/slate"
import Video from "./video"
import EmailVideo from "./email-video"

const getVideoId = link => {
  if (link.includes("/watch?")) {
    return new URL(link).searchParams.get("v")
  } else {
    return link
      .split("/")
      .pop()
      .split("?")
      .shift()
  }
}

export default {
  component: Video,
  email: EmailVideo,
  commands: {
    insertVideo: (editor, { href, ...attributes }) => {
      const videoId = getVideoId(href)

      editor.insertBlock({
        type: "video",
        data: { href, videoId, ...attributes },
        nodes: [Text.create("")]
      })
    }
  },
  schema: {
    isVoid: true
  }
}
